export const GRID_EDITOR_POPOUT_WINDOW_NAME = 'gridEditorPopoutWindow';
export const GRID_EDITOR_POST_MESSAGE_BRIDGE_ID = 'GRID_EDITOR';
export const GRID_EDITOR_ROOT_ID = 'grid-editor-root';
export const GRID_EDITOR_IFRAME_BODY = 'grid-editor-iframe-body';
export const ROW_HEADER_WIDTH = 60;
